import useInIframe from '../../hooks/useInIframe'
import Button from '../../components/Button'
import Icon from '../../components/Icon'
import useLiveQuery from '@/hooks/useLiveQuery'

export default function PreviewMode<T>({
  query,
  params,
  initialData,
  children,
}: {
  query: string
  params?: Record<string, unknown>
  initialData: T
  children: (data: T) => React.ReactElement
}) {
  const { data, loading, refresh } = useLiveQuery(query, params, initialData)
  const inIframe = useInIframe()
  const urlSearchParams: Record<string, string> = { query }

  if (params) {
    urlSearchParams.params = JSON.stringify(params)
  }

  return (
    <>
      <div
        style={{
          zIndex: 100,
          position: 'fixed',
          bottom: 'var(--margin)',
          right: 'var(--margin)',
          display: 'flex',
          gap: '0.5rem',
        }}
      >
        <Button
          small
          onClick={refresh}
        >
          {loading ? 'Oppdaterer…' : 'Oppdatér'}
        </Button>
        {!inIframe && (
          <>
            <Button
              small
              primary
              onClick={() => {
                fetch('/api/preview-end', { method: 'POST' }).then(() => {
                  window.location.reload()
                })
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Icon icon="close" />
                &nbsp;Avslutt forhåndsvisning
              </div>
            </Button>
          </>
        )}
      </div>
      {children(data || initialData)}
    </>
  )
}
